// retryUtils.ts - Retry logic with exponential backoff for chunked uploaders

const DEFAULT_BASE_DELAY = 1000;
const DEFAULT_MAX_DELAY = 10000;

/**
 * Calculate exponential backoff delay
 * @param attempt - Current attempt number (1-based)
 * @param baseDelay - Base delay in milliseconds
 * @param maxDelay - Maximum delay cap in milliseconds
 */
export function calculateBackoff(
  attempt: number,
  baseDelay: number = DEFAULT_BASE_DELAY,
  maxDelay: number = DEFAULT_MAX_DELAY
): number {
  const delay = Math.min(baseDelay * Math.pow(2, attempt - 1), maxDelay);
  return delay;
}
